import industries from "../data/industries";
import Icon from "./Icon";
import SectionHeading from "./SectionHeading";

function Industries() {
  return (
    <section className="section" id="industries">
      <div className="container">
        <SectionHeading
          eyebrow="Domain Expertise"
          title="Industries We Serve"
          subtitle="Deep experience across sectors — we build software that understands the way your industry works."
        />
        <div className="card-grid card-grid--3 reveal">
          {industries.map((industry) => (
            <article className="card-grid__item" key={industry.id}>
              <div className="industry-card">
                <div className="industry-card__icon">
                  <Icon name={industry.icon} size={40} />
                </div>
                <span className="industry-card__label">{industry.label}</span>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Industries;
